import type { FC } from 'react';
import React from 'react';
import type { FilledIconsEnum } from '~/Features/FilledIconsEnum.csharp';
import { SvgIconBase } from './SvgIconBase';
import { assetPathBuilder } from './Utils/Utils';

export type FilledIconName = `${FilledIconsEnum}`;

interface FilledSvgIconProps {
    iconName: FilledIconName;
    className?: string;
}

export const FilledSvgIcon: FC<React.PropsWithChildren<FilledSvgIconProps>> = props => {
    const { iconName, className } = props;
    const iconPath = assetPathBuilder(iconName, true);

    return <SvgIconBase path={iconPath} className={className} />;
};
